import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left-arrow-crm",
  "use": "icon-left-arrow-crm-usage",
  "viewBox": "0 0 13 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 23\" id=\"icon-left-arrow-crm\"><path d=\"M.334 10.622L10.622.338a1.159 1.159 0 0 1 1.636 0c.451.45.451 1.181 0 1.632l-9.472 9.468 9.47 9.469c.452.45.452 1.181 0 1.633-.45.45-1.183.45-1.635 0L.333 12.255a1.165 1.165 0 0 1 .001-1.633z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol